<div class="cashin-container">
  @if (isLoading()) {
    <app-spinner />
  }
  <ngx-app-bar
    class="w-100"
    [title]="'افزایش موجودی کیف پول'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />
  <div class="cashin-content">
    <div class="cashin-card gap-medium d-flex flex-column">
      <div class="wallet-balance">
        <div class="d-flex wallet-description b-1 justify-content-center gap-small">
          قدرت خرید
          <img
            [className]="'cursor-pointer'"
            src="wealth-assets/icons/question.svg"
            alt="قدرت خرید"
          />
        </div>
        <div class="wallet-amount">
          <span class="wallet-number">{{ balance().balance | number }}</span>
          <span class="is-currency">ریال</span>
        </div>
      </div>
      <div class="wallet-balance">
        <div class="d-flex wallet-description b-1 justify-content-center gap-small">
          موجودی قابل برداشت
          <img
            [className]="'cursor-pointer'"
            src="wealth-assets/icons/question.svg"
            alt="قدرت خرید"
          />
        </div>
        <div class="wallet-amount">
          <span class="wallet-number">{{ balance().withdrawalBalance | number }}</span>
          <span class="is-currency">ریال</span>
        </div>
      </div>
    </div>
    <wealth-applet-wallet-amount-form
      class="w-100 cashin-content"
      [minAmount]="minAmount()"
      [maxAmount]="maxAmount()"
      [type]="'cashIn'"
      [title]="'مبلغ افزایش موجودی را وارد کنید.'"
      (amountChange)="amountChanged($event)"
    />
    <div class="cashin-buttons">
      <ngx-button
        [style]="'fill'"
        [fullWidth]="true"
        [mode]="'form'"
        size="medium"
        [disabled]="!isValid()"
        (clickHandler)="cashin()"
        [buttonId]="'CASH_IN_CONFIRM'"
      >
        تایید و ادامه
      </ngx-button>
    </div>
  </div>
</div>
